(() => {
  const dialog = document.getElementById('NayabPhotoZoom');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const photo = dialog.querySelector('img');
  const toggle = dialog.querySelector('[data-zoom-toggle]');
  let opener, previousOverflow, images = [], index = 0, startX = 0, startY = 0, pinchDistance = 0, pinchScale = 1, scale = 1;
  const count = dialog.querySelector('[data-photo-count]');
  document.querySelectorAll('.product-information media-gallery .product-media img').forEach(image => {
    image.tabIndex = 0;
    image.setAttribute('role', 'button');
    image.setAttribute('aria-label', `Open photo: ${image.alt || 'Product photo'}`);
    image.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); image.click(); }
    });
  });
  function setScale(value) {
    scale = Math.max(1, Math.min(3, value));
    dialog.classList.toggle('is-zoomed', scale > 1);
    photo.style.width = scale > 1 ? `${scale * 100}%` : '';
    toggle.textContent = scale > 1 ? 'Zoom −' : 'Zoom +';
    toggle.setAttribute('aria-label', scale > 1 ? 'Zoom out' : 'Zoom in');
    toggle.setAttribute('aria-pressed', String(scale > 1));
  }
  function showPhoto(next) {
    index = (next + images.length) % images.length;
    photo.src = images[index].src; photo.alt = images[index].alt;
    count.textContent = `${index + 1} / ${images.length}`;
    dialog.querySelectorAll('[data-photo-prev],[data-photo-next]').forEach(button => button.disabled = images.length < 2);
    setScale(1);
    dialog.querySelector('.nr-zoom-scroll').scrollTo(0, 0);
  }
  function setZoom(zoomed) {
    setScale(zoomed ? 2 : 1);
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const image = event.target.closest('.product-information media-gallery .product-media img');
    if (!image || image.closest('dialog') || !image.currentSrc) return;
    event.preventDefault(); event.stopImmediatePropagation();
    opener = image.closest('button, a') || image;
    const gallery = image.closest('media-gallery');
    const largeSource = source => { const url = new URL(source, location.href); url.searchParams.set('width', '2000'); return url.href; };
    images = [...gallery.querySelectorAll('.product-media img')].filter(img => img.currentSrc).map(img => ({src: largeSource(img.currentSrc), alt: img.alt || 'Product photo'})).filter((img, at, all) => all.findIndex(other => other.src === img.src) === at);
    showPhoto(Math.max(0, images.findIndex(img => img.src === largeSource(image.currentSrc))));
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    dialog.querySelector('[data-zoom-close]').focus();
  }, true);
  toggle.addEventListener('click', () => setZoom(!dialog.classList.contains('is-zoomed')));
  photo.addEventListener('click', () => setZoom(!dialog.classList.contains('is-zoomed')));
  dialog.querySelector('[data-photo-prev]').addEventListener('click', () => showPhoto(index - 1));
  dialog.querySelector('[data-photo-next]').addEventListener('click', () => showPhoto(index + 1));
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowRight') showPhoto(index + 1);
    if (event.key === 'ArrowLeft') showPhoto(index - 1);
  });
  const distance = touches => Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
  const area = dialog.querySelector('.nr-zoom-scroll');
  area.addEventListener('touchstart', event => {
    if (event.touches.length === 2) { pinchDistance = distance(event.touches); pinchScale = scale; }
    else { pinchDistance = 0; startX = event.touches[0].clientX; startY = event.touches[0].clientY; }
  }, {passive: true});
  area.addEventListener('touchmove', event => {
    if (event.touches.length === 2 && pinchDistance) { event.preventDefault(); setScale(pinchScale * distance(event.touches) / pinchDistance); }
  }, {passive: false});
  area.addEventListener('touchend', event => {
    if (pinchDistance || !event.changedTouches.length) return;
    const dx = event.changedTouches[0].clientX - startX, dy = event.changedTouches[0].clientY - startY;
    if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) showPhoto(index + (dx < 0 ? 1 : -1));
  }, {passive: true});
  dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    setZoom(false); opener?.focus?.({ preventScroll: true });
  });
})();